import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/outline';
import Button from '@ui/atoms/design-system/Button';
import { cn } from '@ui/atoms/utils/utils';
const PrevButton = ({ className, isMobile = false, onClick, disabled }) => (
    <Button
        buttonType="secondary"
        className={cn(
            'w-11 h-11 rounded-full p-0',
            isMobile
                ? ''
                : 'absolute -left-16 top-[calc(50%+24px)] -translate-y-1/2 mx-auto text-center ',
            className
        )}
        widthClass="w-11 h-11 !p-0"
        disabled={disabled}
        onClick={onClick}
        buttonText={
            <ArrowLeftIcon className="w-4 h-4 mx-auto text-center text-primary-500" />
        }
    />
);

const NextButton = ({ className, isMobile = false, onClick, disabled }) => (
    <Button
        buttonType="secondary"
        className={cn(
            'w-11 h-11 rounded-full p-0',
            isMobile
                ? ''
                : 'absolute -right-16 top-[calc(50%+24px)] -translate-y-1/2',
            className
        )}
        widthClass="w-11 h-11 !p-0"
        disabled={disabled}
        onClick={onClick}
        buttonText={
            <ArrowRightIcon className="w-4 h-4 mx-auto text-center text-primary-500" />
        }
    />
);

export { PrevButton, NextButton };
